export default __webpack_public_path__ + "static/atlassian-ai-397802ddd92c237ef2642fb8b57e1ae8.png";